import { useState } from "react";
import { LoginInfo } from "../login/login";

function ChangePassword() {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  return (
    <LoginInfo>
      <section className="login-page">
        <div className="container">
          <div className="login-form">
            <div className="form-header">
              <h1>Reset your password..!</h1>
              <p>Type a new password and confirm it.</p>
            </div>
            <form>
              <div className="form-inputs">
                <div className="form-group inputWithIcon">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    placeholder="Password *"
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="fa-envelope"
                  >
                    <path
                      d="M2 16C2 13.172 2 11.757 2.879 10.879C3.757 10 5.172 10 8 10H16C18.828 10 20.243 10 21.121 10.879C22 11.757 22 13.172 22 16C22 18.828 22 20.243 21.121 21.121C20.243 22 18.828 22 16 22H8C5.172 22 3.757 22 2.879 21.121C2 20.243 2 18.828 2 16Z"
                      stroke="black"
                      stroke-opacity="0.4"
                      stroke-width="1.5"
                    />
                    <path
                      d="M6 10V8C6 6.4087 6.63214 4.88258 7.75736 3.75736C8.88258 2.63214 10.4087 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8V10"
                      stroke="black"
                      stroke-opacity="0.4"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M8 16H8.009M11.991 16H12M15.991 16H16"
                      stroke="black"
                      stroke-opacity="0.4"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <i
                    className={`fa-regular  ${
                      passwordVisible ? "fa-eye" : "fa-eye-slash"
                    }`}
                    onClick={togglePasswordVisibility}
                    style={{ cursor: "pointer" }}
                  ></i>
                </div>
                <div className="form-group inputWithIcon">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    placeholder="Confirm Password *"
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="fa-envelope"
                  >
                    <path
                      d="M2 16C2 13.172 2 11.757 2.879 10.879C3.757 10 5.172 10 8 10H16C18.828 10 20.243 10 21.121 10.879C22 11.757 22 13.172 22 16C22 18.828 22 20.243 21.121 21.121C20.243 22 18.828 22 16 22H8C5.172 22 3.757 22 2.879 21.121C2 20.243 2 18.828 2 16Z"
                      stroke="black"
                      stroke-opacity="0.4"
                      stroke-width="1.5"
                    />
                    <path
                      d="M6 10V8C6 6.4087 6.63214 4.88258 7.75736 3.75736C8.88258 2.63214 10.4087 2 12 2C13.5913 2 15.1174 2.63214 16.2426 3.75736C17.3679 4.88258 18 6.4087 18 8V10"
                      stroke="black"
                      stroke-opacity="0.4"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M8 16H8.009M11.991 16H12M15.991 16H16"
                      stroke="black"
                      stroke-opacity="0.4"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <i
                    className={`fa-regular  ${
                      passwordVisible ? "fa-eye" : "fa-eye-slash"
                    }`}
                    onClick={togglePasswordVisibility}
                    style={{ cursor: "pointer" }}
                  ></i>
                </div>
              </div>

              <button type="submit">Submit</button>
            </form>
          </div>
          <div className="login-background">
            <img
              src={
                process.env.PUBLIC_URL +
                "/photos/257cdf6122cadf5b56b96eddf37c41ea.webp"
              }
              alt="login-background"
            />
          </div>
        </div>
      </section>
    </LoginInfo>
  );
}
export default ChangePassword;
